import {
  RETRIEVE_COMPARE_BEGIN,
  RETRIEVE_COMPARE_SUCCESS,
  RETRIEVE_COMPARE_FAILURE,
} from './constants';
import {
  MONTH_UNIT,
  DAY_UNIT,
  HOUR_UNIT
} from '../../shared-components/chart/redux/constants'
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';
import moment from 'moment';
const EMOTION_AND_SENTIMENT_TREND_CHART_IDS = ['102', '103'];

function getQueryUnit(date) {
  const startDate = moment(date.fromDate);
  const endDate = moment(date.toDate);
  const diffDays = endDate.diff(startDate, 'days');
  if (diffDays !== 0 && diffDays <= 180) {
    return DAY_UNIT;
  } else if (diffDays === 0) {
    return HOUR_UNIT;
  } else {
    return MONTH_UNIT;
  }
}

function createUrls(dataReceive, queryUnit) {
  const urls = dataReceive.topicId.map(topicId => {
    const twoUrlsForTwoChartIds = EMOTION_AND_SENTIMENT_TREND_CHART_IDS.map(chartId => {
      return `${apiEndPoints.charts.RETRIEVE_CHART_BY_ID}${chartId}&fromDate=${
        dataReceive ? dataReceive.dateRangeFilterValue.fromDate : ''
      }&toDate=${dataReceive ? dataReceive.dateRangeFilterValue.toDate : ''}&unit=${
        EMOTION_AND_SENTIMENT_TREND_CHART_IDS.indexOf(chartId) !== -1 ? queryUnit : 'total'
      }&topicId=${topicId}&sources=${dataReceive.sources}`;
    });
    return twoUrlsForTwoChartIds;
  });
  return urls;
}

export function retrieveCompare(props = {}) {
  const dataReceive = props;
  const queryUnit = typeof props === 'object' ? getQueryUnit(props.dateRangeFilterValue) : DAY_UNIT;
  return dispatch => {
    dispatch({
      type: RETRIEVE_COMPARE_BEGIN,
    });
    const urls = createUrls(dataReceive, queryUnit);

    return Promise.all(
      urls.map(twoUrlsForTwoChartIds => {
        return Promise.all(
          twoUrlsForTwoChartIds.map(url => {
            const promise = new Promise((resolve, reject) => {
              const doRequest = http.get(url);
              doRequest.then(
                res => {
                  resolve(res);
                },
                err => {
                  reject(err);
                },
              );
            });
            return promise;
          }),
        );
      }),
    ).then(
      res => {
        const reponseData = res.map(twoItems => {
          return twoItems.map(item => item.data.data);
        });
        dispatch({
          type: RETRIEVE_COMPARE_SUCCESS,
          data: {
            data: reponseData,
          },
        });
      },
      err => {
        dispatch({
          type: RETRIEVE_COMPARE_FAILURE,
        });
      },
    );
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case RETRIEVE_COMPARE_BEGIN:
      return {
        ...state,
        retrieve_compare_begin: true,
        retrieve_compare_success: false,
        retrieve_compare_error: false,
      };
    case RETRIEVE_COMPARE_SUCCESS:
      state.topicCompareData = action.data.data;
      return {
        ...state,
        retrieve_compare_begin: false,
        retrieve_compare_success: true,
      };

    case RETRIEVE_COMPARE_FAILURE:
      return {
        ...state,
        retrieve_compare_begin: false,
        retrieve_compare_error: true,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/retrieveCompare.js